import { CheckCircle2, AlertTriangle, XCircle, Clock, Loader2 } from "lucide-react";

const styles = {
  valid: {
    bg: "bg-emerald-50",
    text: "text-emerald-800",
    border: "border-emerald-200",
    icon: CheckCircle2,
    label: "Valid",
  },
  expiring: {
    bg: "bg-amber-50",
    text: "text-amber-800",
    border: "border-amber-200",
    icon: Clock,
    label: "Expiring Soon",
  },
  expired: {
    bg: "bg-red-50",
    text: "text-red-800",
    border: "border-red-200",
    icon: XCircle,
    label: "Expired",
  },
  pending_review: {
    bg: "bg-slate-100",
    text: "text-slate-700",
    border: "border-slate-300",
    icon: Loader2,
    label: "Pending Review",
  },
  cleared: {
    bg: "bg-emerald-50",
    text: "text-emerald-800",
    border: "border-emerald-200",
    icon: CheckCircle2,
    label: "Ready for Site",
  },
  review: {
    bg: "bg-amber-50",
    text: "text-amber-800",
    border: "border-amber-200",
    icon: AlertTriangle,
    label: "Action Required",
  },
  not_cleared: {
    bg: "bg-red-50",
    text: "text-red-800",
    border: "border-red-200",
    icon: XCircle,
    label: "Not Eligible",
  },
};

export default function StatusBadge({ status, label, testid }) {
  const s = styles[status] || styles.valid;
  const Icon = s.icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap border ${s.border} ${s.bg} ${s.text} px-2.5 py-1 text-xs font-semibold uppercase tracking-wide`}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={2.25} />
      {label || s.label}
    </span>
  );
}
